<template>
  <div class="flex q-ma-lg justify-center">
    <p class="text-italic">{{ greet }}</p>
    <q-btn label="сканер" @click="goToScaner" />
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { ref } from 'vue';

export default { name: 'DashboardView' };
</script>
<script setup lang="ts">

const greet = ref('Бобро пожаловац');

const goToScaner = () => {
  router.push({ name: 'DocumentScanner' });
};
</script>

<style scoped>

</style>
